// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"8b655c4d","242":"579f9d67","667":"b762609b","972":"75727d39"}[chunkId] + ".chunk.css";
};